/**
 * Configuración centralizada de variables de entorno
 *
 * Este archivo centraliza todas las variables de entorno
 * y proporciona valores por defecto seguros
 */

export const ENV = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_URL ||
           (import.meta.env.PROD
             ? 'https://chilenito-fahaasgdb3d4hpdw.canadacentral-01.azurewebsites.net'
             : 'http://localhost:5000'),

  // App Information
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Chilenito E-commerce',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Environment
  IS_PRODUCTION: import.meta.env.PROD,
  IS_DEVELOPMENT: import.meta.env.DEV,
} as const;

// Log configuration in development
if (ENV.IS_DEVELOPMENT) {
  console.log('🔧 Environment Configuration:', ENV);
}

export default ENV;
